import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/Login';
import PasswordReset from '@/components/PasswordReset';
import PasswordUpdate from '@/components/PasswordUpdate';
import SiteSelection from '@/components/SiteSelection';
import TemplateSelection from '@/components/TemplateSelection';
import Website from '@/components/Website';
import BasicInformation from '@/components/BasicInformation';
import SiteLayout from '@/components/SiteLayout';
import Contact from '@/components/Contact';
import ExportPdf from '@/components/ExportPdf';
import store from '@/store';
import Admin from '@/components/admin/Admin';
import AdminLogin from '@/components/admin/Login';
import AdminUsers from '@/components/admin/Users';
import AdminAdminUsers from '@/components/admin/AdminUsers';
import AdminContacts from '@/components/admin/Contacts';
import AdminContactsCSV from '@/components/admin/ContactsCSV';
import SiteList from '@/components/admin/SiteList';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { requiresAuth: false },
    },
    {
      path: '/reset-password',
      name: 'PasswordReset',
      component: PasswordReset,
      meta: { requiresAuth: false },
    },
    {
      path: '/update-password',
      name: 'PasswordUpdate',
      component: PasswordUpdate,
      meta: { requiresAuth: false },
    },
    {
      path: '/select-site',
      name: 'SiteSelection',
      component: SiteSelection,
      meta: { requiresAuth: true },
    },
    {
      path: '/select-template',
      name: 'TemplateSelection',
      component: TemplateSelection,
      meta: { requiresAuth: true },
    },
    {
      path: '/website',
      name: 'Website',
      component: Website,
      meta: { requiresAuth: true, requiresSite: true },
      children: [
        {
          path: 'basic',
          name: 'BasicInformation',
          component: BasicInformation,
          meta: { requiresAuth: true, requiresSite: true },
        },
        {
          path: 'update-template',
          name: 'TemplateUpdate',
          component: TemplateSelection,
          meta: { requiresAuth: true, requiresSite: true },
        },
        {
          path: 'layout',
          name: 'SiteLayout',
          component: SiteLayout,
          meta: { requiresAuth: true, requiresSite: true },
        },
        {
          path: 'contact',
          name: 'Contact',
          component: Contact,
          meta: { requiresAuth: true, requiresSite: true },
        },
        {
          path: 'export-pdf',
          name: 'ExportPdf',
          component: ExportPdf,
          meta: { requiresAuth: true, requiresSite: true },
        },
      ],
    },
    {
      path: '/admin-login',
      name: 'AdminLogin',
      component: AdminLogin,
      meta: { requiresAdmin: false },
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      meta: { requiresAdmin: true },
      children: [
        {
          path: 'users',
          name: 'AdminUsers',
          component: AdminUsers,
          meta: { requiresAdmin: true },
        },
        {
          path: 'contacts/:sid',
          name: 'AdminContacts',
          component: AdminContacts,
          meta: { requiresAdmin: true },
        },
        {
          path: 'contacts-csv',
          name: 'AdminContactsCSV',
          component: AdminContactsCSV,
          meta: { requiresAdmin: true },
        },
        {
          path: 'admin-users',
          name: 'AdminAdminUsers',
          component: AdminAdminUsers,
          meta: {
            requiresAdmin: true,
            requiresSuperuser: true,
          },
        },
        {
          path: 'site-list',
          name: 'SiteList',
          component: SiteList,
          meta: {
            requiresAdmin: true,
            requiresSuperuser: true,
          },
        },
        { path: '*', redirect: { name: 'AdminLogin' } },
      ],
    },
    { path: '*', redirect: { name: 'Login' } },
  ],
});

router.beforeEach((to, from, next) => {
  const { matched } = to;
  const { isLogined, isAdminLogined, isSuperuserLogined } = store.getters;
  if (matched.some(record => record.meta.requiresAuth !== undefined)) {
    if (matched.some(record => record.meta.requiresAuth)) {
      if (!isLogined) {
        next({ name: 'Login' });
        return;
      }
    } else if (isLogined) {
      next({ name: 'SiteSelection' });
      return;
    }
  }
  if (matched.some(record => record.meta.requiresAdmin !== undefined)) {
    if (matched.some(record => record.meta.requiresAdmin)) {
      if (!isAdminLogined) {
        next({ name: 'AdminLogin' });
        return;
      }
    } else if (isAdminLogined) {
      next({ name: 'AdminUsers' });
      return;
    }
  }
  if (matched.some(record => record.meta.requiresSuperuser !== undefined)) {
    if (matched.some(record => record.meta.requiresSuperuser)) {
      if (!isSuperuserLogined) {
        next({ name: 'AdminUsers' });
        return;
      }
    }
  }
  if (matched.some(record => record.meta.requiresSite)) {
    if (!store.getters.hasSiteId) {
      next({ name: 'SiteSelection' });
      return;
    }
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js